module.exports = __webpack_public_path__ + "static/media/tracy_04.f5d64c66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/album/tracy_04.jpg
// module id = 382
// module chunks = 0